import { render, staticRenderFns } from "./OperateTenantDialog.vue?vue&type=template&id=09f581ea"
import script from "./OperateTenantDialog.vue?vue&type=script&lang=js"
export * from "./OperateTenantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports